/**
 * `useOfficials({ leagueId })` embeds the league's membership
 * (`league_officials!inner(league_id, status, category, position)`). Grade and rank
 * are per league (migration 20261012094117): the membership wins, the person's value
 * is the fallback. The embed itself is dropped from the row.
 */
export interface LeagueMembershipEmbed {
  league_id: string;
  status?: string | null;
  category?: string | null;
  position?: number | null;
}

export function applyLeagueMembership(
  row: Record<string, any>,
  leagueId: string | null | undefined
): Record<string, any> {
  const { league_officials: raw, ...rest } = row;
  if (!leagueId) return rest;
  const list: LeagueMembershipEmbed[] = Array.isArray(raw) ? raw : raw ? [raw] : [];
  const membership = list.find((m) => m.league_id === leagueId);
  if (!membership) return rest;
  return {
    ...rest,
    category: membership.category ?? rest.category,
    position: membership.position ?? rest.position,
  };
}
